import React, { useState } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaTable } from 'react-icons/fa';
import Data from '../../../components/Data';
import ReactSelect from '../../../components/ReactSelect';
import api from '../../../services/api';
import '../../../css/financeiro-parcela-pagar.css';

export default function ExportarEventoExecucao() {
    const token = localStorage.getItem('token');
    const empresa = localStorage.getItem("empresa");
    const [filtro, setFiltro] = useState({
        empresa: empresa,
    });

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Gerar Planilha BI - Execução</h1></div>
                    <div className="fin-pp__actions"></div>
                </div>

                <form method="post" target="_blank" action={process.env.REACT_APP_API_URL + "/evento/exportarEventoExecucao"}>
                    <input type="hidden" name="token" value={token} />
                    <input type="hidden" name="empresa" value={empresa} />

                    <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                        <div className="fin-pp__filters">
                            <div className="fin-pp__field">
                                <Data
                                    inputName="data1"
                                    label="Data"
                                    value={filtro.data1}
                                    onChange={date => setFiltro({ ...filtro, ...{ "data1": date } })}
                                />
                            </div>
                            <div className="fin-pp__field">
                                <Data
                                    inputName="data2"
                                    label="até a Data"
                                    value={filtro.data2}
                                    onChange={date => setFiltro({ ...filtro, ...{ "data2": date } })}
                                />
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 24 }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary">
                            <FaTable size={16} /> Gerar Planilha
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
